import { useTranslation } from 'react-i18next';

import type { StaticTextType } from '../components/uiParts/StaticTextCard';

export const clientTermText = (): StaticTextType => {
  const { t } = useTranslation();
  return {
    body: [
      {
        ordered: [
          { text: t('clientTerm.1.ordered.1') },
          { text: t('clientTerm.1.ordered.2') },
          { text: t('clientTerm.1.ordered.3') },
          { text: t('clientTerm.1.ordered.4') },
          { text: t('clientTerm.1.ordered.5') },
          { text: t('clientTerm.1.ordered.6') },
          { text: t('clientTerm.1.ordered.7') }
        ],
        text: t('clientTerm.1.desc'),
        title: t('clientTerm.1.title'),
        type: 'textAndOrderd'
      },
      {
        ordered: [
          { text: t('clientTerm.2.ordered.1') },
          { text: t('clientTerm.2.ordered.2') },
          { text: t('clientTerm.2.ordered.3') }
        ],
        title: t('clientTerm.2.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.3.ordered.1') },
          { text: t('clientTerm.3.ordered.2') },
          { text: t('clientTerm.3.ordered.3') },
          { text: t('clientTerm.3.ordered.4') }
        ],
        title: t('clientTerm.3.title'),
        type: 'ordered'
      },
      {
        text: t('clientTerm.4.desc'),
        title: t('clientTerm.4.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('clientTerm.5.ordered.1') },
          { text: t('clientTerm.5.ordered.2') }
        ],
        title: t('clientTerm.5.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.6.ordered.1') },
          { text: t('clientTerm.6.ordered.2') },
          { text: t('clientTerm.6.ordered.3') }
        ],
        title: t('clientTerm.6.title'),
        type: 'ordered'
      },
      {
        text: t('clientTerm.7.desc'),
        title: t('clientTerm.7.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('clientTerm.8.ordered.1') },
          { text: t('clientTerm.8.ordered.2') }
        ],
        title: t('clientTerm.8.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('clientTerm.9.ordered.1.ordered.1') },
              { text: t('clientTerm.9.ordered.1.ordered.2') },
              { text: t('clientTerm.9.ordered.1.ordered.3') },
              { text: t('clientTerm.9.ordered.1.ordered.4') },
              { text: t('clientTerm.9.ordered.1.ordered.5') },
              { text: t('clientTerm.9.ordered.1.ordered.6') },
              { text: t('clientTerm.9.ordered.1.ordered.7') },
              { text: t('clientTerm.9.ordered.1.ordered.8') },
              { text: t('clientTerm.9.ordered.1.ordered.9') }
            ],
            text: t('clientTerm.9.ordered.1.text')
          },
          {
            ordered: [
              { text: t('clientTerm.9.ordered.2.ordered.1') },
              { text: t('clientTerm.9.ordered.2.ordered.2') },
              { text: t('clientTerm.9.ordered.2.ordered.3') }
            ],
            text: t('clientTerm.9.ordered.2.text')
          }
        ],
        title: t('clientTerm.9.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('clientTerm.10.ordered.1.ordered.1') },
              { text: t('clientTerm.10.ordered.1.ordered.2') },
              { text: t('clientTerm.10.ordered.1.ordered.3') },
              { text: t('clientTerm.10.ordered.1.ordered.4') },
              { text: t('clientTerm.10.ordered.1.ordered.5') },
              { text: t('clientTerm.10.ordered.1.ordered.6') },
              { text: t('clientTerm.10.ordered.1.ordered.7') }
            ],
            text: t('clientTerm.10.ordered.1.text')
          },
          { text: t('clientTerm.10.ordered.2.text') },
          { text: t('clientTerm.10.ordered.3.text') }
        ],
        title: t('clientTerm.10.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.11.ordered.1') },
          { text: t('clientTerm.11.ordered.2') },
          { text: t('clientTerm.11.ordered.3') },
          { text: t('clientTerm.11.ordered.4') },
          { text: t('clientTerm.11.ordered.5') },
          { text: t('clientTerm.11.ordered.6') }
        ],
        title: t('clientTerm.11.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.12.ordered.1') },
          { text: t('clientTerm.12.ordered.2') }
        ],
        title: t('clientTerm.12.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.13.ordered.1') },
          { text: t('clientTerm.13.ordered.2') }
        ],
        title: t('clientTerm.13.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.14.ordered.1.text') },
          {
            ordered: [
              { text: t('clientTerm.14.ordered.2.ordered.1') },
              { text: t('clientTerm.14.ordered.2.ordered.2') },
              { text: t('clientTerm.14.ordered.2.ordered.3') },
              { text: t('clientTerm.14.ordered.2.ordered.4') },
              { text: t('clientTerm.14.ordered.2.ordered.5') }
            ],
            text: t('clientTerm.14.ordered.2.text')
          },
          { text: t('clientTerm.14.ordered.3.text') },
          { text: t('clientTerm.14.ordered.4.text') },
          { text: t('clientTerm.14.ordered.5.text') }
        ],
        title: t('clientTerm.14.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('clientTerm.15.ordered.1.ordered.1') },
              { text: t('clientTerm.15.ordered.1.ordered.2') },
              { text: t('clientTerm.15.ordered.1.ordered.3') },
              { text: t('clientTerm.15.ordered.1.ordered.4') },
              { text: t('clientTerm.15.ordered.1.ordered.5') }
            ],
            text: t('clientTerm.15.ordered.1.text')
          },
          {
            ordered: [
              { text: t('clientTerm.15.ordered.2.ordered.1') },
              { text: t('clientTerm.15.ordered.2.ordered.2') },
              { text: t('clientTerm.15.ordered.2.ordered.3') },
              { text: t('clientTerm.15.ordered.2.ordered.4') },
              { text: t('clientTerm.15.ordered.2.ordered.5') }
            ],
            text: t('clientTerm.15.ordered.2.text')
          },
          { text: t('clientTerm.15.ordered.3.text') },
          { text: t('clientTerm.15.ordered.4.text') }
        ],
        title: t('clientTerm.15.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.16.ordered.1') },
          { text: t('clientTerm.16.ordered.2') }
        ],
        title: t('clientTerm.16.title'),
        type: 'ordered'
      },
      {
        text: t('clientTerm.17.desc'),
        title: t('clientTerm.17.title'),
        type: 'textOnly'
      },
      {
        text: t('clientTerm.18.desc'),
        title: t('clientTerm.18.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('clientTerm.19.ordered.1') },
          { text: t('clientTerm.19.ordered.2') }
        ],
        title: t('clientTerm.19.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('clientTerm.20.ordered.1') },
          { text: t('clientTerm.20.ordered.2') }
        ],
        title: t('clientTerm.20.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('clientTerm.21.ordered.1.ordered.1') },
              { text: t('clientTerm.21.ordered.1.ordered.2') }
            ],
            text: t('clientTerm.21.ordered.1.text')
          },
          { text: t('clientTerm.21.ordered.2.text') },
          { text: t('clientTerm.21.ordered.3.text') }
        ],
        title: t('clientTerm.21.title'),
        type: 'ordered'
      },
      {
        text: t('clientTerm.22.desc'),
        title: t('clientTerm.22.title'),
        type: 'textOnly'
      },
      {
        text: t('clientTerm.23.desc'),
        title: t('clientTerm.23.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('clientTerm.24.ordered.1') },
          { text: t('clientTerm.24.ordered.2') },
          { text: t('clientTerm.24.ordered.3') }
        ],
        title: t('clientTerm.24.title'),
        type: 'ordered'
      }
    ],
    bottomText: t('clientTerm.bottomText'),
    pageTitle: t('clientTerm.pageTitle')
  };
};

export const mediaTermText = (): StaticTextType => {
  const { t } = useTranslation();
  return {
    body: [
      {
        ordered: [
          { text: t('mediaTerm.1.ordered.1') },
          { text: t('mediaTerm.1.ordered.2') },
          { text: t('mediaTerm.1.ordered.3') },
          { text: t('mediaTerm.1.ordered.4') },
          { text: t('mediaTerm.1.ordered.5') },
          { text: t('mediaTerm.1.ordered.6') },
          { text: t('mediaTerm.1.ordered.7') }
        ],
        text: t('mediaTerm.1.desc'),
        title: t('mediaTerm.1.title'),
        type: 'textAndOrderd'
      },
      {
        ordered: [
          { text: t('mediaTerm.2.ordered.1') },
          { text: t('mediaTerm.2.ordered.2') },
          { text: t('mediaTerm.2.ordered.3') }
        ],
        title: t('mediaTerm.2.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.3.ordered.1') },
          { text: t('mediaTerm.3.ordered.2') },
          { text: t('mediaTerm.3.ordered.3') },
          { text: t('mediaTerm.3.ordered.4') }
        ],
        title: t('mediaTerm.3.title'),
        type: 'ordered'
      },
      {
        text: t('mediaTerm.4.desc'),
        title: t('mediaTerm.4.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          {
            text: t('mediaTerm.5.ordered.1.text')
          }
        ],
        title: t('mediaTerm.5.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.6.ordered.1') },
          { text: t('mediaTerm.6.ordered.2') },
          { text: t('mediaTerm.6.ordered.3') }
        ],
        title: t('mediaTerm.6.title'),
        type: 'ordered'
      },
      {
        text: t('mediaTerm.7.desc'),
        title: t('mediaTerm.7.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('mediaTerm.8.ordered.1') },
          { text: t('mediaTerm.8.ordered.2') }
        ],
        title: t('mediaTerm.8.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('mediaTerm.9.ordered.1.ordered.1') },
              { text: t('mediaTerm.9.ordered.1.ordered.2') },
              { text: t('mediaTerm.9.ordered.1.ordered.3') },
              { text: t('mediaTerm.9.ordered.1.ordered.4') },
              { text: t('mediaTerm.9.ordered.1.ordered.5') },
              { text: t('mediaTerm.9.ordered.1.ordered.6') },
              { text: t('mediaTerm.9.ordered.1.ordered.7') },
              { text: t('mediaTerm.9.ordered.1.ordered.8') },
              { text: t('mediaTerm.9.ordered.1.ordered.9') }
            ],
            text: t('mediaTerm.9.ordered.1.text')
          },
          {
            ordered: [
              { text: t('mediaTerm.9.ordered.2.ordered.1') },
              { text: t('mediaTerm.9.ordered.2.ordered.2') },
              { text: t('mediaTerm.9.ordered.2.ordered.3') }
            ],
            text: t('mediaTerm.9.ordered.2.text')
          }
        ],
        title: t('mediaTerm.9.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('mediaTerm.10.ordered.1.ordered.1') },
              { text: t('mediaTerm.10.ordered.1.ordered.2') },
              { text: t('mediaTerm.10.ordered.1.ordered.3') },
              { text: t('mediaTerm.10.ordered.1.ordered.4') },
              { text: t('mediaTerm.10.ordered.1.ordered.5') },
              { text: t('mediaTerm.10.ordered.1.ordered.6') },
              { text: t('mediaTerm.10.ordered.1.ordered.7') }
            ],
            text: t('mediaTerm.10.ordered.1.text')
          },
          { text: t('mediaTerm.10.ordered.2.text') },
          { text: t('mediaTerm.10.ordered.3.text') }
        ],
        title: t('mediaTerm.10.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.11.ordered.1') },
          { text: t('mediaTerm.11.ordered.2') },
          { text: t('mediaTerm.11.ordered.3') },
          { text: t('mediaTerm.11.ordered.4') },
          { text: t('mediaTerm.11.ordered.5') },
          { text: t('mediaTerm.11.ordered.6') }
        ],
        title: t('mediaTerm.11.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.12.ordered.1') },
          { text: t('mediaTerm.12.ordered.2') }
        ],
        title: t('mediaTerm.12.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.13.ordered.1') },
          { text: t('mediaTerm.13.ordered.2') }
        ],
        title: t('mediaTerm.13.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.14.ordered.1.text') },
          {
            ordered: [
              { text: t('mediaTerm.14.ordered.2.ordered.1') },
              { text: t('mediaTerm.14.ordered.2.ordered.2') },
              { text: t('mediaTerm.14.ordered.2.ordered.3') },
              { text: t('mediaTerm.14.ordered.2.ordered.4') },
              { text: t('mediaTerm.14.ordered.2.ordered.5') }
            ],
            text: t('mediaTerm.14.ordered.2.text')
          },
          { text: t('mediaTerm.14.ordered.3.text') },
          { text: t('mediaTerm.14.ordered.4.text') },
          { text: t('mediaTerm.14.ordered.5.text') }
        ],
        title: t('mediaTerm.14.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('mediaTerm.15.ordered.1.ordered.1') },
              { text: t('mediaTerm.15.ordered.1.ordered.2') },
              { text: t('mediaTerm.15.ordered.1.ordered.3') },
              { text: t('mediaTerm.15.ordered.1.ordered.4') },
              { text: t('mediaTerm.15.ordered.1.ordered.5') }
            ],
            text: t('mediaTerm.15.ordered.1.text')
          },
          {
            ordered: [
              { text: t('mediaTerm.15.ordered.2.ordered.1') },
              { text: t('mediaTerm.15.ordered.2.ordered.2') },
              { text: t('mediaTerm.15.ordered.2.ordered.3') },
              { text: t('mediaTerm.15.ordered.2.ordered.4') },
              { text: t('mediaTerm.15.ordered.2.ordered.5') }
            ],
            text: t('mediaTerm.15.ordered.2.text')
          },
          { text: t('mediaTerm.15.ordered.3.text') },
          { text: t('mediaTerm.15.ordered.4.text') }
        ],
        title: t('mediaTerm.15.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.16.ordered.1') },
          { text: t('mediaTerm.16.ordered.2') }
        ],
        title: t('mediaTerm.16.title'),
        type: 'ordered'
      },
      {
        text: t('mediaTerm.17.desc'),
        title: t('mediaTerm.17.title'),
        type: 'textOnly'
      },
      {
        text: t('mediaTerm.18.desc'),
        title: t('mediaTerm.18.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('mediaTerm.19.ordered.1') },
          { text: t('mediaTerm.19.ordered.2') }
        ],
        title: t('mediaTerm.19.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('mediaTerm.20.ordered.1') },
          { text: t('mediaTerm.20.ordered.2') }
        ],
        title: t('mediaTerm.20.title'),
        type: 'ordered'
      },
      {
        ordered: [
          {
            ordered: [
              { text: t('mediaTerm.21.ordered.1.ordered.1') },
              { text: t('mediaTerm.21.ordered.1.ordered.2') }
            ],
            text: t('mediaTerm.21.ordered.1.text')
          },
          { text: t('mediaTerm.21.ordered.2.text') },
          { text: t('mediaTerm.21.ordered.3.text') }
        ],
        title: t('mediaTerm.21.title'),
        type: 'ordered'
      },
      {
        text: t('mediaTerm.22.desc'),
        title: t('mediaTerm.22.title'),
        type: 'textOnly'
      },
      {
        text: t('mediaTerm.23.desc'),
        title: t('mediaTerm.23.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('mediaTerm.24.ordered.1') },
          { text: t('mediaTerm.24.ordered.2') },
          { text: t('mediaTerm.24.ordered.3') }
        ],
        title: t('mediaTerm.24.title'),
        type: 'ordered'
      }
    ],
    bottomText: t('mediaTerm.bottomText'),
    bottomText2: t('mediaTerm.bottomText2'),
    pageTitle: t('mediaTerm.pageTitle')
  };
};

export const privacyText = (): StaticTextType => {
  const { t } = useTranslation();
  return {
    body: [
      {
        text: t('privacy.1.desc'),
        title: t('privacy.1.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('privacy.2.ordered.1') },
          { text: t('privacy.2.ordered.2') },
          { text: t('privacy.2.ordered.3') },
          { text: t('privacy.2.ordered.4') },
          { text: t('privacy.2.ordered.5') },
          { text: t('privacy.2.ordered.6') },
          { text: t('privacy.2.ordered.7') },
          { text: t('privacy.2.ordered.8') },
          { text: t('privacy.2.ordered.9') },
          { text: t('privacy.2.ordered.10') }
        ],
        text: t('privacy.2.desc'),
        title: t('privacy.2.title'),
        type: 'textAndOrderd'
      },
      {
        ordered: [
          { text: t('privacy.3.ordered.1') },
          { text: t('privacy.3.ordered.2') },
          { text: t('privacy.3.ordered.3') }
        ],
        text: t('privacy.3.desc'),
        title: t('privacy.3.title'),
        type: 'textAndOrderd'
      },
      {
        text: t('privacy.4.desc'),
        title: t('privacy.4.title'),
        type: 'textOnly'
      },
      {
        ordered: [
          { text: t('privacy.5.ordered.1') },
          { text: t('privacy.5.ordered.2') },
          { text: t('privacy.5.ordered.3') }
        ],
        text: t('privacy.5.desc'),
        title: t('privacy.5.title'),
        type: 'textAndOrderd'
      },
      {
        ordered: [
          { text: t('privacy.6.ordered.1') },
          { text: t('privacy.6.ordered.2') },
          { text: t('privacy.6.ordered.3') }
        ],
        title: t('privacy.6.title'),
        type: 'ordered'
      },
      {
        ordered: [
          { text: t('privacy.7.ordered.1') },
          { text: t('privacy.7.ordered.2') },
          { text: t('privacy.7.ordered.3') }
        ],
        title: t('privacy.7.title'),
        type: 'ordered'
      },
      {
        text: t('privacy.8.desc'),
        title: t('privacy.8.title'),
        type: 'textOnly'
      },
      {
        text: t('privacy.9.desc'),
        title: t('privacy.9.title'),
        type: 'textOnly'
      },
      {
        text: t('privacy.10.desc'),
        title: t('privacy.10.title'),
        type: 'textOnly'
      },
      {
        text: t('privacy.11.desc'),
        title: t('privacy.11.title'),
        type: 'textOnly'
      },
      {
        text: t('privacy.12.desc'),
        title: t('privacy.12.title'),
        type: 'textOnly'
      },
      {
        text: t('privacy.13.desc'),
        title: t('privacy.13.title'),
        type: 'textOnly'
      }
    ],
    bottomText: t('privacy.bottomText'),
    description: t('privacy.description'),
    pageTitle: t('privacy.pageTitle')
  };
};
